import classNames from 'classnames';
import React from 'react';

import { XIcon } from '@icons';
import { setupForDark } from '@theme';

function Sidebar({
  isOpen,
  side,
  onClose,
  children,
  withX = true,
  withBackdrop = true,
  width = '500px'
}: {
  isOpen: boolean;
  side: 'left' | 'right';
  onClose: () => void;
  children: React.ReactNode;
  withX?: boolean;
  withBackdrop?: boolean;
  width?: string;
}) {
  const backdropClasses = `fixed inset-0 bg-black opacity-5 z-40 transition-opacity duration-300 ${
    isOpen ? 'visible opacity-5' : 'invisible opacity-0'
  }`;

  return (
    <>
      {/* Backdrop */}
      {withBackdrop && (
        <div
          className={backdropClasses}
          onClick={onClose}
          style={{ display: isOpen ? 'block' : 'none' }}
        ></div>
      )}

      {/* Sidebar */}
      {isOpen && (
        <div
          className={classNames('fixed top-0 h-full z-50', side === 'left' ? 'left-0' : 'right-0')}
          style={{ width: width }}
        >
          {withX && (
            <div
              className={classNames(
                'absolute top-md right-md',
                'cursor-pointer',
                setupForDark('text-icon-secondary')
              )}
              onClick={onClose}
            >
              <XIcon size={24}></XIcon>
            </div>
          )}
          {children}
        </div>
      )}
    </>
  );
}

export default Sidebar;
